import HCLDX from "@system/config/hcldx";
import System from "src/helper/system";
const c = System.getParams();

class Admin {
  //USER
  
  static USER_LIST = System.getAdminConsoleUrl() + '/api/admin/users';
  static DELETE_USERS = System.getAdminConsoleUrl() + `/api/admin/delete`;
  static EXPORT_USER_LIST = System.getAdminConsoleUrl() + `/api/admin/userExport`;
  static EMAIL_USER_LIST = System.getAdminConsoleUrl() + `/api/admin/emailUsers`;
  static ADD_USER = System.getAdminConsoleUrl() + `/api/admin/adduser`;
  static GET_USER_DETAIL = System.getAdminConsoleUrl() + `/api/admin/details`;
  static GET_WEB_USER_SHIPPING_ADDRESS_DETAIL = System.getAdminConsoleUrl() + `/api/admin/getWebShippingAddress`;
  static SAVE_WEB_USER_SHIPPING_ADDRESS = System.getAdminConsoleUrl() + `/api/admin/saveShippingAddress`;


  static GET_USER_ACCT_LIST = System.getAdminConsoleUrl() + `/api/admin/accounts`;
  static GET_USER_SEARCH_ACCT_LIST = System.getAdminConsoleUrl() + `/api/admin/getallaccounts`;
  static UPDATE_USER_UNSPONSOR_ACCT = System.getAdminConsoleUrl() + `/api/admin/unsponsoredaccounts`;
  static UPDATE_USER_UNSPONSOR_ACCT_BY_USER = System.getAdminConsoleUrl() + `/api/admin/unsponsoredaccountsbyUsers`;
  static CHECK_USER_EMAIL = System.getAdminConsoleUrl() + `/api/admin/internalUserDetails`;
  static SEARCH_SPONSOR_ACCOUNTS = System.getAdminConsoleUrl() + `/api/admin/searchSponsorAccounts`;
  
  static UPDATE_USER_DETAIL = System.getAdminConsoleUrl() + `/api/admin/edituser`;
  static UPDATE_USER_ACTIVE_STATUS = System.getAdminConsoleUrl() + `/api/admin/setUserStatus`;
  static UPDATE_USER_SPONSORSHIP = System.getAdminConsoleUrl() + `/api/admin/addRolestoAccounts`;
  // Account
  static ACCOUNT_LIST = System.getAdminConsoleUrl() + '/api/admin/listofaccount';
  static ACCOUNT_DETAIL = System.getAdminConsoleUrl() + '/api/admin/users';
  static ACCOUNT_USER_LIST = System.getAdminConsoleUrl() + '/api/admin/users';
  static EMAIL_ACCOUNT_LIST = System.getAdminConsoleUrl() + '/api/admin/exportaccountsandsendmail';
  static EMAIL_ACCOUNT_USER_LIST = System.getAdminConsoleUrl() + '/api/admin/sendMailForAccountUserList';
  static ACCOUNT_EXPORT = System.getAdminConsoleUrl() + '/api/admin/exportaccountstoexcel';
  static EXPORT_ACCOUNT_USER_LIST = System.getAdminConsoleUrl() + '/api/admin/exportAccountUserList';

  static GET_ACCOUNT_DETAIL = System.getAdminConsoleUrl() + `/api/admin/AccountDetail`;
  static GET_ACCOUNT_USER_LIST = System.getAdminConsoleUrl() + `/api/admin/GetAccountSpecificUserAccounts`;
  // Reports
  static REPORTS_LIST = System.getAdminConsoleUrl() + '/api/admin/getlistofUserandAccountReport';
  static EXPORT_REPORT_LIST = System.getAdminConsoleUrl() + '/api/admin/exportAccountAndUsersReport';

  static EMAIL_REPORT_LIST = System.getAdminConsoleUrl() + '/api/admin/emailAccountAndUsersReport';
  // Admin
  static GET_ROLE_LIST = System.getAdminConsoleUrl() + `/api/admin/roles`;
  static GET_ORG_LIST = System.getAdminConsoleUrl() + `/api/admin/salesorglist`;
  static EDIT_USER_ROLES = System.getAdminConsoleUrl() + `/api/admin/editUserRoles`;
  static GET_BOM_VIEWER = System.getAdminConsoleUrl() + `/api/admin/bomDataViewer`;
  static GET_BOM_VIEWER_DETAILS = System.getAdminConsoleUrl() + `/api/admin/bomDataInsights`;
  static GET_COMPLIANCE_LIST = System.getAdminConsoleUrl() + `/api/admin/GetExportComplianceData`;
  static EXPORT_COMPLIANCE_SURVEY = System.getCartUrl() + `/api/order/amer/admin/DownloadExportCompliance`;

  // Order
  static ADMIN_ORDER = System.getOrderUrl() + `/api/order/amer/admin/orderDetails`;
  static ADMIN_ORDER_INSIGHT_INFO = System.getOrderUrl() + `/api/order/amer/admin/orderAdminDetails`;
  static ADMIN_ORDER_INSIGHT = System.getOrderUrl() + `/api/order/amer/admin/orderAdminCartDetails`;
  static ADMIN_ORDER_REPROCESS = System.getOrderUrl() + `/api/order/amer/admin/orderReprocess`;
  static ADMIN_ORDER_INSIGHT_EXPORT_ALL = System.getOrderUrl() + `/api/order/amer/admin/orderAdminCartDetailsExport`;
  static ADMIN_ORDER_AUDIT_LOG = System.getOrderUrl() + `/api/order/amer/admin/orderAuditLog`;
  static ADMIN_ORDER_UPDATE_DETAILS = System.getOrderUrl() + `/api/order/amer/admin/orderUpdate`;

  static getAdminURL() {
    return HCLDX.baseURL() + "/resources/myavnet/admin/user-account-manager";
  }

  static getUserDetailURL() {
    return HCLDX.baseURL() + "/resources/myavnet/admin/detail";
  }

  static getAccountDetailURL() {
    return HCLDX.baseURL() + "/resources/myavnet/admin/account/detail";
  }

  static getRegistrationURL() {
    return HCLDX.baseURL() + "/authenticate/register";
  }

  static getBomManagerURL() {
    return HCLDX.baseURL() + '/resources/myavnet/admin/bom-manager';
  }

  static getBomManagerDetailsURL() {
    return HCLDX.baseURL() + '/resources/myavnet/admin/bom-manager/details';
  }
  
  static getComplianceManagerURL() {
    return HCLDX.baseURL() + '/resources/myavnet/admin/compliance-manager';
  }


  static getAdminOrderURL() {
    return HCLDX.baseURL() + "/resources/myavnet/admin/orders";
  }

  static getAdminOrderInsightURL() {
    return HCLDX.baseURL() + "/resources/myavnet/admin/orders/insight";
  }
}

export default Admin;
